import { render } from "./FormLogo.vue?vue&type=template&id=2a7b99ca"
import script from "./FormLogo.vue?vue&type=script&lang=js"
export * from "./FormLogo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/patientReport/header/FormLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a7b99ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a7b99ca', __exports__)) {
    console.log('reload')
    api.reload('2a7b99ca', __exports__)
  }
  
  module.hot.accept("./FormLogo.vue?vue&type=template&id=2a7b99ca", () => {
    console.log('re-render')
    api.rerender('2a7b99ca', render)
  })

}


export default __exports__